"use strict";

var images = document.querySelectorAll(".gallery-preview");
images.forEach(function (img) {
  return img.classList.add("transition");
});
var _backgroundSequence = function backgroundSequence() {
  window.clearTimeout();
  var k = 0;
  for (var i = 0; i < images.length; i++) {
    setTimeout(function () {
      document.querySelectorAll(".gallery-preview").forEach(function (preview) {
        preview.classList.add("opacity-0");
      });
      if (images[k]) {
        images[k].classList.remove("opacity-0");
      }
      if (k + 1 === images.length) {
        setTimeout(_backgroundSequence, 2000);
      } else {
        k++;
      }
    }, 3000 * i);
  }
};
if (images.length > 1) {
  _backgroundSequence();
}
//# sourceMappingURL=galleryPreview.js.map